import { useEffect, useRef } from 'react';

/**
 * Lorem ipsum
 * @param initialValue boolean
 * @returns ref
 * @see Overlay Table
 */
export default function useMounted(initialValue = true) {
  const isMountedRef = useRef(initialValue);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
